import script from "./nowData.vue?vue&type=script&setup=true&lang=js"
export * from "./nowData.vue?vue&type=script&setup=true&lang=js"

import "./nowData.vue?vue&type=style&index=0&id=45b75364&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45b75364"]])

export default __exports__